import { render } from "./ExpendBind.vue?vue&type=template&id=0cce15de"
import script from "./ExpendBind.vue?vue&type=script&lang=js"
export * from "./ExpendBind.vue?vue&type=script&lang=js"

import exportComponent from "D:\\phpstudy_pro\\WWW\\guolang\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__